const Messages = {
  GENERIC_ERROR: 'An error occured while handling your request. Please reach out to support@advicepay.com if this issue persists.'
}
export default Messages;